import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { computed, inject } from '@angular/core';
import { TokenService } from 'src/app/auth/services/token/token.service';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  const _service = inject(TokenService);
  const token = _service.token();

  if (req.context.get(BYPASS_JW_TOKEN) === false) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  }

  return next(req);
};

export const BYPASS_JW_TOKEN = new HttpContextToken(() => false);
